import { getContentListService } from "modules/Services/AnalyticsService";
import { ANALYTICS_DATA_EXPORT, ANALYTICS_INTENT_DATA, CONTENT_ANALYTICS } from "constants/types";
import store from "store";
import { setFirstTimeAllDataShown } from "../Dashboard/actions";

export const getPaginatedContentData = (params: any, callback?: any) => {
  if (!params.exportAnalytics)
    store.dispatch({
      type: params.offset === 0 ? CONTENT_ANALYTICS.LOAD : CONTENT_ANALYTICS.LOAD_MORE,
    });
  const firstTimeFilterShown = store.getState().analyticsDashboard.firstAllDataShown;
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  getContentListService(params)
    .then((response: any) => {
      if (params.exportAnalytics) {
        store.dispatch({
          type: ANALYTICS_DATA_EXPORT.SET_OPEN,
          payload: response.data.email_address,
        });
      } else {
        const actionType: any =
          params.offset === 0 ? CONTENT_ANALYTICS.LOAD_SUCCESS : CONTENT_ANALYTICS.LOAD_MORE_SUCCESS;
        store.dispatch({
          type: actionType,
          payload: { data: response.data },
        });
        if (!firstTimeFilterShown) {
          setFirstTimeAllDataShown(true);
        }
      }
      store.dispatch({
        type: CONTENT_ANALYTICS.FILTER_RESET,
        payload: false,
      });
      store.dispatch({
        type: CONTENT_ANALYTICS.SEARCH_RESET,
        payload: params.searchWord !== "" ? true : false,
      });
      if (response.data.total_articles_count) {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: response.data.total_articles_count > 0 ? false : true,
        });
      } else {
        // if the articles are already in store then we need to enable export button
        let articles = store.getState().analyticsContent.data;
        if (articles.length > 0) {
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: false,
          });
        }
      }
      if (callback)
        setTimeout(() => {
          callback(false);
        }, 500);
    })
    .catch((err) => {
      console.error(err);
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: CONTENT_ANALYTICS.LOAD_FAIL,
        });
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: true,
        });
      }
    });
};

export const resetContentData = () => {
  store.dispatch({
    type: CONTENT_ANALYTICS.RESET,
  });
};

export const sortArticleContacts = (sortDirection: any, articleId: any, index: number) => {
  store.dispatch({
    type: CONTENT_ANALYTICS.CLICKED_CONTACTS_SORT,
    payload: {
      sort: sortDirection,
      articleId,
      index,
    },
  });
};
